export default __webpack_public_path__ + "static/media/p-get-started-img-03.bc33e8d3.png";